const SubList = ({ children }) => {
  return (
    <ul style={{
      listStyle: "none",
      padding: "4px 0 4px 16px",
      margin: 0,
      borderLeft: "2px solid #e8f0fe",
      marginLeft: "20px",
    }}>
      {children}
    </ul>
  );
};

export default SubList;
